<header>
  <app-navbar></app-navbar>
</header>
<main>
  <router-outlet></router-outlet>
</main>
@if (showCopy()) {
  <footer class="text-center text-muted small">Copyright Digital Oilfield {{ today | date: 'yyyy' }}. All rights reserved.</footer>
}
